import DoneIcon from '@mui/icons-material/Done';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';

const SalesforceTaskCompletedBanner = ({ task }) => {
    return (
        <Box
            sx={{
                mx: 3,
                mt: 3,
                mb: 0,
                px: 2,
                py: 1.5,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                borderRadius: 1,
                backgroundColor: 'status.green.bg',
                border: '1px solid',
                borderColor: 'signal.green',
            }}
        >
            <DoneIcon
                sx={{
                    color: 'signal.green',
                    fontSize: 22,
                    flexShrink: 0,
                }}
            />

            <Box>
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 700,
                        lineHeight: 1.2,
                        color: 'status.green.text',
                    }}
                >
                    Completed today
                </Typography>

                <Typography
                    sx={{
                        mt: 0.25,
                        fontSize: '12px',
                        lineHeight: 1.3,
                        color: 'text.secondary',
                    }}
                >
                    Marked complete at{' '}
                    {dayjs(task.completed_at).format('h:mm A')}
                </Typography>
            </Box>
        </Box>
    )
}

export default SalesforceTaskCompletedBanner;